import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { CurrencyInfo } from '../../report-data/models/currency-info.model';
import { Card } from './card.model';
import { ReportType } from './report-type.model';

export const DASHBOARD_SCHEMA = Object.freeze({
  CURRENCY_INFO: CurrencyInfo,
  ENTRIES: List<Card>([]),
  REPORT_LIST: List<ReportType>([]),
});
const RECORD = generateSchema(DASHBOARD_SCHEMA);
const KEYS: any = generateKeys(DASHBOARD_SCHEMA);

export class Dashboard extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CURRENCY_INFO,
        value: new CurrencyInfo(this.currencyInfo),
      },
      {
        key: KEYS.ENTRIES,
        value: props.get(KEYS.ENTRIES)
          ? this.dashboardEntries.map((params) => new Card(params))
          : List<Card>([]),
      },
      {
        key: KEYS.REPORT_LIST,
        value: props.get(KEYS.REPORT_LIST)
          ? this.reportList.map((params) => new ReportType(params))
          : List<ReportType>([]),
      },
    ]);

    return selfModel as Dashboard;
  }

  get currencyInfo(): CurrencyInfo {
    return this.get(KEYS.CURRENCY_INFO);
  }

  get dashboardEntries(): List<Card> {
    return this.get(KEYS.ENTRIES);
  }

  get reportList(): List<ReportType> {
    return this.get(KEYS.REPORT_LIST);
  }
}
